import { Spinner, Message } from '..'
import { inputText, inputTextArea } from '../../utils/dynamicForm'

const FormClientPermissions = ({
  edit,
  formCleanHandler,
  isLoading,
  register,
  isError,
  errors,
  isLoadingUpdate,
  isLoadingPost,
  handleSubmit,
  submitHandler,
  error,
}) => {
  return (
    <div
      className='modal fade'
      id='clientPermissionModal'
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='clientPermissionModalLabel'
    >
      <div className='modal-dialog'>
        <div className='modal-content modal-background'>
          <div className='modal-header'>
            <h3 className='modal-title ' id='clientPermissionModalLabel'>
              {edit ? 'Editar permiso de cliente' : 'Permiso de cliente de publicación'}
            </h3>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={formCleanHandler}
            ></button>
          </div>
          <div className='modal-body'>
            {isLoading ? (
              <Spinner />
            ) : isError ? (
              <Message variant='danger'>{error}</Message>
            ) : (
              <form onSubmit={handleSubmit(submitHandler)}>
                {inputText({
                  register,
                  errors,
                  label: 'Nombre',
                  name: 'name',
                  placeholder: 'Nombre',
                })}
                {inputText({
                  register,
                  errors,
                  label: 'Menu',
                  name: 'menu',
                  placeholder: 'Menu',
                })}
                {inputText({
                  register,
                  errors,
                  label: 'Ruta',
                  name: 'path',
                  placeholder: 'Ruta',
                })}

                {inputTextArea({
                  register,
                  errors,
                  label: 'Descripción',
                  name: 'description',
                  placeholder: 'Descripción',
                  isRequired: false,
                })}

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-secondary '
                    data-bs-dismiss='modal'
                    onClick={formCleanHandler}
                  >
                    Cerrar
                  </button>
                  <button
                    type='submit'
                    className='btn btn-primary '
                    disabled={isLoadingPost || isLoadingUpdate}
                  >
                    {isLoadingPost || isLoadingUpdate ? (
                      <span className='spinner-border spinner-border-sm' />
                    ) : (
                      'Enviar'
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormClientPermissions
